import { useQuery } from '@tanstack/react-query';

import { getMonthlyBills } from '@/apis/company';
import { QUERY_KEY } from '@/constants/queryKey';
import type { GetMonthlyBillsRequestProps } from '@/types/company.types';

const useMonthlyBills = (params?: GetMonthlyBillsRequestProps) => {
  const query = useQuery(
    [QUERY_KEY.MONTHLY_BILLS, params],
    () => getMonthlyBills(params),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  );

  return query;
};

export default useMonthlyBills;

